import * as Phaser from 'phaser';

export class BaseScene extends Phaser.Scene {
  constructor(key: string, options?: Phaser.Types.Scenes.SettingsConfig) {
    super({ key, ...options });
  }
  
  protected centerX(): number {
    return this.cameras.main.width / 2;
  }
  
  protected centerY(): number {
    return this.cameras.main.height / 2;
  }
  
  // Common utility methods can go here
  protected createButton(x: number, y: number, text: string, callback: () => void): Phaser.GameObjects.Text {
    const button = this.add.text(x, y, text, {
      fontSize: '24px',
      color: '#ffffff',
      backgroundColor: '#444444',
      padding: { x: 20, y: 10 },
    })
      .setOrigin(0.5)
      .setInteractive()
      .setPadding(20)
      .on('pointerover', () => button.setStyle({ backgroundColor: '#666666' }))
      .on('pointerout', () => button.setStyle({ backgroundColor: '#444444' }))
      .on('pointerdown', callback);
    
    return button;
  }
}